import type { TemplatedReportType } from "@validereinc/domain";

/**
 * Get a readable version of the name assigned to a templated report when
 * generated. When the `name_format` property doesn't exist, it will just be the
 * `display_name`. If it does exist, a `name` for the report does not have to be
 * provided when creating one and the `name_format` will be used instead to
 * automatically assign one to the generated report in the back-end.
 */
export const getNameFormatReadable = (
  reportTemplateDetails: TemplatedReportType
): string => {
  if (!reportTemplateDetails.name_format)
    return reportTemplateDetails.display_name;

  // this string will have variables in it in the format $(variable) where
  // variable can be referencing the templates inputs like so
  // 'inputs.the_input_name'
  let readableNameFormat = reportTemplateDetails.name_format;

  for (const [inputId, inputDetails] of Object.entries(
    reportTemplateDetails.input_schema
  )) {
    readableNameFormat = readableNameFormat.replaceAll(
      `$(inputs.${inputId})`,
      `$(${inputDetails.display_name})`
    );
  }

  return readableNameFormat;
};
